module.exports = __webpack_public_path__ + "img/logo_dted_red.ade2a418.svg";